import React from 'react'
import SimpleContentPicture from '../SimpleContentPicture'
import Section from '@/components/Section'
import Container from '@/components/Container'
import IconDiamond from '@/components/IconDiamond'
import Image from '@/components/Image'
import useImageProps from '@/hooks/useImageProps'
import getCloudinaryUrl from '@/utils/getCloudinaryUrl'
import { maxPhoneScreen } from '../../../../utils/screenBreakpointsUtils'

const transformImageUrl = (url) =>
  getCloudinaryUrl(url.split('/upload/').pop(), 'q_50,w_640,ar_4:3,c_fill')

const smallImageUrl = transformImageUrl(
  'https://res.cloudinary.com/rehabpath/image/upload/q_50,f_webp/v1695913541/standalone-luxury-rehab-page-legacy-small.png'
)
const largeImageUrl = transformImageUrl(
  'https://res.cloudinary.com/rehabpath/image/upload/q_50,f_webp/v1695913542/standalone-luxury-rehab-page-legacy-large.png'
)

const LuxuryImageComponent = () => {
  return (
    <picture>
      <source
        media={`(max-width:${maxPhoneScreen})`}
        srcSet={smallImageUrl}
      ></source>
      <Image
        {...useImageProps({
          loading: 'lazy',
          src: largeImageUrl
        })}
      />
    </picture>
  )
}

const LuxuryContentPicture = () => {
  const title = 'Explore All Luxury Treatment Centers'
  const content =
    'Luxury rehab centers offer a unique blend of luxurious amenities and high-quality treatment. From private suites to gourmet dining, personal trainers to spa treatments, these facilities provide a high level of comfort and discretion.'
  const link = {
    link: '/luxury/',
    text: 'Top 50 Rehabs in the World'
  }

  return (
    <div className="mb-6 mt-12 md:mb-12">
      <Section>
        <Container>
          <SimpleContentPicture
            title={title}
            content={content}
            link={link}
            imageElement={<LuxuryImageComponent />}
            IconComponent={IconDiamond}
          ></SimpleContentPicture>
        </Container>
      </Section>
    </div>
  )
}

export default LuxuryContentPicture
